import React, { useState, useEffect } from "react";

export default function CaseHearingForm({ onSubmit, selectedCase }) {
  const [formData, setFormData] = useState({
    caseNumber: "",
    caseType: "",
    versus: "",
    hearingDate: "",
    nextHearingDate: "",
    status: "",
    remarks: "",
  });

  useEffect(() => {
    if (selectedCase) setFormData(selectedCase);
  }, [selectedCase]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form className="p-4 bg-white shadow rounded" onSubmit={handleSubmit}>
      <h4 className="mb-3">{selectedCase ? "Edit Case" : "Add New Case"}</h4>

      <div className="row g-3">
        <div className="col-md-4">
          <label>Case Number</label>
          <input
            name="caseNumber"
            className="form-control"
            value={formData.caseNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Case Type</label>
          <input
            name="caseType"
            className="form-control"
            value={formData.caseType}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Versus</label>
          <input
            name="versus"
            className="form-control"
            value={formData.versus}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Hearing Date</label>
          <input
            type="date"
            name="hearingDate"
            className="form-control"
            value={formData.hearingDate.split("T")[0] || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Next Hearing Date</label>
          <input
            type="date"
            name="nextHearingDate"
            className="form-control"
            value={formData.nextHearingDate.split("T")[0] || ""}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-4">
          <label>Status</label>
          <select
            name="status"
            className="form-control"
            value={formData.status}
            onChange={handleChange}
            required
          >
            <option value="">- Select -</option>
            <option>Pending</option>
            <option>Heard</option>
            <option>Closed</option>
          </select>
        </div>

        <div className="col-md-12">
          <label>Remarks</label>
          <textarea
            name="remarks"
            className="form-control"
            value={formData.remarks}
            onChange={handleChange}
          />
        </div>
      </div>

      <button type="submit" className="btn btn-primary mt-3">
        {selectedCase ? "Update" : "Save"}
      </button>
    </form>
  );
}
